// src/components/charts/MockShareChip.jsx
//
// Inline chip: "N run mock su M totali". Hidden when there are no mock runs.
// Sourced from two `groupBy=status` calls (mock-excluded vs mock-included).
//
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FONT_SANS, SEMANTIC } from '../../constants/theme.js';

const FONT = FONT_SANS;

/**
 * Compute mock count + total from the two stats responses.
 * Returns { mock, total } or null when input is incomplete.
 * Exported for unit testing.
 */
export function computeMockShare(realOnly, withMock) {
  if (!realOnly || !withMock) return null;
  const real  = realOnly.total || 0;
  const total = withMock.total || 0;
  const mock  = Math.max(0, total - real);
  return { mock, total };
}

export default function MockShareChip({ realOnly, withMock }) {
  const { t } = useTranslation('dashboard');
  const share = computeMockShare(realOnly, withMock);
  if (!share || share.mock === 0) return null;
  return (
    <div style={{
      display: 'inline-flex', alignItems: 'center', gap: 6,
      padding: '4px 10px', borderRadius: 999,
      background: SEMANTIC.attenzione.bg, color: SEMANTIC.attenzione.fg,
      fontFamily: FONT, fontSize: 11, fontWeight: 600,
      marginBottom: 16,
    }}>
      <span aria-hidden>•</span>
      <span>{t('mockChip', { mock: share.mock, total: share.total })}</span>
    </div>
  );
}
